import { MOONPAY_WIDGET_CONTAINER_ID } from '../constants';
import type {
  MoonPayWebSdkConfig,
  OnUrlSignatureRequested,
  StylingProps,
} from '../types';
import { useSdk } from '../useSdk';

interface MoonPayWidgetProps extends StylingProps {
  onUrlSignatureRequested?: OnUrlSignatureRequested;
  visible?: boolean;
  config: MoonPayWebSdkConfig;
}

const defaultStyles = {
  width: '424px',
  height: '576px',
  margin: '32px 28px 32px 28px',
  border: '1px solid #E5E7EB',
  'border-radius': '16px',
  overflow: 'hidden',
};

export function MoonPayWidget({
  config,
  onUrlSignatureRequested,
  visible = true,
  className,
  style,
}: MoonPayWidgetProps) {
  useSdk(config, visible, onUrlSignatureRequested);

  if (visible) {
    return (
      <div
        id={MOONPAY_WIDGET_CONTAINER_ID}
        className={className}
        style={
          config.variant === 'embedded'
            ? {
                ...defaultStyles,
                ...style,
              }
            : undefined
        }
      />
    );
  }

  return null;
}
